// @flow
import * as apple from './apple'

const selectors = { apple }

export default selectors
